import React from "react";

//export const SESSION_URL = "http://127.0.0.1:8000";
//export const SESSION_URL = "https://www.itopstocks.com/";
//export const SESSION_URL = "https://alpharesearch.online/";
//export const SESSION_URL = "https://alpharesearch.opencminc.com/";
//export const SESSION_URL = "https://vps-48149b0f.vps.ovh.us/";
//export const SESSION_URL = "http://localhost:8000";
//export const SESSION_URL = "http://45.79.25.243:280"
//export const SESSION_URL = "http://173.255.196.62:280"
export const PORTAL_URL = "https://vps-b7780821.vps.ovh.us:10443"
export const SESSION_URL = "https://vps-b7780821.vps.ovh.us:10443"
//export const PORTAL_URL = "http://127.0.0.1:8000"
